import { render, staticRenderFns } from "./AdminBusCompaniesRow.vue?vue&type=template&id=89c3d744&"
import script from "./AdminBusCompaniesRow.vue?vue&type=script&lang=js&"
export * from "./AdminBusCompaniesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports